import { Injectable } from "@angular/core";
import { Firestore, doc } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { BehaviorSubject, tap } from "rxjs";
import { Restaurant } from "src/interfaces/restaurant.model";
import { convertLanguagesMap } from "../utils/convert-language";
import { Table } from "src/interfaces/table.model";
import { Details } from "src/interfaces/details.model";

@Injectable({
    providedIn: 'root'
})
export class RestaurantsService {
    private restaurantSubject = new BehaviorSubject<Restaurant | null>(null);
    public restaurant$ = this.restaurantSubject.asObservable();

    constructor(private store: Firestore) { }

    public subscribeToRestaurant(id: string): void {
        const docRef = doc(this.store, 'stores', id);
        docData(docRef, { idField: 'id' }).pipe(
            tap(rawRestaurant => {
                const restaurant = this.transformRestaurant(rawRestaurant);
                this.restaurantSubject.next(restaurant);
            })
        ).subscribe();
    }

    public getRestaurant(): Restaurant | null {
        return this.restaurantSubject.getValue();
    }

    private transformRestaurant(restaurant: any): Restaurant {
        console.log('RestaurantService | transformRestaurant() | restaurant:', restaurant);
        return {
            ...restaurant,
            details: this.transformDetails(restaurant.details || new Map()),
            payment: restaurant.payment || false,
            groupId: restaurant.groupId?.toString() || null,
            languages: convertLanguagesMap(restaurant.languages), // Функция для преобразования restaurant.languages
            tables: this.transformTables(restaurant.tables || []),
        };
    }

    private transformDetails(details: any): Details {
        // Нормализуем вход
        let map: Map<string, string | null>;
        if (!details) {
            map = new Map();
        } else if (details instanceof Map) {
            map = details;
        } else {
            // если пришёл обычный объект
            map = new Map(Object.entries(details));
        }

        return {
            title: map.get('title') || '',
            inn: map.get('inn') || '',
            kpp: map.get('kpp') || '',
            ogrn: map.get('ogrn') || '',
            address: map.get('address') || '',
            email: map.get('email') || '',
            phone: map.get('phone') || '',
        };
    }

    private transformTables(tables: any[]): Table[] {
        return tables.map(table => ({
            id: table.qrCode, // Используем qrCode как id
            active: table.active,
            index: table.index, // Преобразуем number в string
            description: table.description,
            waiters: table.waiters || [], // Устанавливаем пустой массив, если waiters отсутствует
            waiterCall: table.waiterCall === true,
        }));
    }
}